/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import * as AppActions from 'src/app/modules/ngrx-store/app/app.actions';

/**
 * Reset the whole state when the logout action is dispatched
 * to prevent state leakage between different users
 * @param reducer
 */
export function stateResetReducerFactory(): MetaReducer<any> {
	return (reducer: ActionReducer<any>) => (state: any, action: Action) => {
		if (action?.type === AppActions.logout.type) {
			return reducer(undefined, action)
		}
		return reducer(state, action);
	}
}